<template>
  <v-container class="signup-container">
    <v-row>
      <v-col
        cols="12"
        xl="4"
        lg="6"
        md="7"
        sm="12"
        offset-md="4"
        offset-lg="4"
        class="mb-8 heading-container"
      >
        <h2 class="mt-15">Sign up to continue</h2>
        <p
          class="signup-subtitle mt-7"
          v-if="['teba', 'oldmutual'].includes(whitelabel.brand)"
        >
          The <strong>first step</strong> in
          <strong>setting up your free will</strong> is creating a profile that
          is linked to your email address.
        </p>
        <p class="signup-subtitle mt-7" v-else>
          The <strong>first step</strong> in
          <strong>setting up your will</strong> is creating a profile that is
          linked to your email address.
        </p>

        <p class="communication-info mt-7">
          We will be using this email address to send all our communications to
          you.
        </p>
      </v-col>
      <v-col cols="12" xl="4" lg="6" md="7" sm="12" offset-md="4">
        <SignUpForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { HOME_QUERY } from '../../../constants/graphql/home';
  import SignUpForm from './SignUpForm.vue';

  export default {
    name: 'SignUpPage',
    metaInfo() {
      return {
        link: [
          {
            rel: 'canonical',
            href: this.whitelabel.canonicalUrls.signup,
          },
        ],
      };
    },
    components: {
      SignUpForm,
    },
  };
</script>
<style lang="scss" scoped>
  h2 {
    font-size: 40px;
  }

  .communication-info {
    font-size: 18px;
  }

  .signup-subtitle {
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
  }

  @media (max-width: 1260px) {
    .signup-container {
      padding: 24px;
      h2 {
        font-size: 30px;
      }

      .signup-subtitle {
        font-size: 20px;
      }

      .communication-info {
        font-size: 16px;
      }
    }
  }
</style>
